import { useTranslation } from 'react-i18next';
import type { DocumentStatus } from '@apis/documents';
import { Pill } from '@components/ui/Pill/Pill';
import styles from './StatusPill.module.css';

export function StatusPill({ status }: { status: DocumentStatus }) {
  const { t } = useTranslation();
  return (
    <Pill className={`${styles.place} ${styles[`status_${status}`]}`}>
      {t(`documents.status.${status}`)}
    </Pill>
  );
}